import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { clearEndpoint } from '../../features/notice/noticeSlice';
import { updateOption} from '../../features/setting/settingSlice';
import NoticeList from './NoticeList';
import NoticeGrid from './NoticeGrid';
import "../../css/modal.css"
import '../../css/style.css';

const Notice = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const categories = useSelector((state) => state.notice.categories);
  const totalCount = useSelector((state) => state.notice.totalCount);
  const admin = useSelector((state) => state.admin.admin);

  const savedCategory = JSON.parse(localStorage.getItem("activeCategory"));
  const defaultCategory = { categoryId: 'NOTI', categoryName: '공지사항' };

  const [selectCategoryID, setSelectCategoryID] = useState(savedCategory?.categoryId || defaultCategory.categoryId);
  const [activeCategory, setActiveCategory] = useState(savedCategory?.categoryId || defaultCategory.categoryId);
  const [activeCategoryName, setActiveCategoryName] = useState(savedCategory?.categoryName || defaultCategory.categoryName);

  const [openModal, setOpenModal] = useState(false);  

  const [errorCntList, setErrorCntList] = useState(false); 
  const [errorCntGrid, setErrorCntGrid] = useState(false); 
  const [errorNoticeDay, setErrorNoticeDay] = useState(false); 

  const settings = useSelector((state) => state.setting.settings);

  const [tempSettings, setTempSettings] = useState([])

  const dataListStyle = () => {
    if (tempSettings.listPage === 'Y') {
      return "pagging"; 
    }
    if (tempSettings.listScroll === 'Y') {
      return "scroll"; 
    }
    return "scroll"; 
  }

  const dataStyle = dataListStyle();

  const [gridMode, setGridMode] = useState(() => JSON.parse(localStorage.getItem('gridmodeEnabled')) || false);
  // true면 grid, false면 list
  const [vsData, setVsData] = useState(gridMode ? "grid" : "list");

  //#region useEffect-목록 양식
  useEffect(()=>{
    localStorage.setItem('gridmodeEnabled', JSON.stringify(gridMode));
    setVsData(gridMode ? "grid" : "list");
  },[gridMode])
  //#endregion

  //#region 카테고리 필터링
  const handleFilter = (categoryId) => {
    setSelectCategoryID(categoryId === '' ? 'NOTI' : categoryId);
    setActiveCategory(categoryId);
    
    // if (categoryId === 'all') {
    //   setActiveCategoryName('전체');
    // } else {
      const selectedCategory = categories.find(category => category.id === categoryId);
      setActiveCategoryName(selectedCategory ? selectedCategory.name : '');
    //}

    //로컬스토리지에 현재 카테고리 저장
    localStorage.setItem("activeCategory", JSON.stringify({
      categoryId,
      categoryName: categoryId === 'all' 
        ? '전체' 
        : (categories.find(c => c.id === categoryId)?.name || '')
    }));
    
    dispatch(clearEndpoint());
  };
  //#endregion

  const goToContentInput = () => { navigate('/notice/content'); };

  //#region Modal창 여닫기
  const handleOpenModal = () => { 
    setOpenModal(true); 
    setTempSettings({
      listPage: settings.listPage,
      listScroll: settings.listScroll,
      listCnt: settings.listViewCount,
      gridCnt: settings.gridViewCount,
      viewDesc: settings.desc,
      viewAsc: settings.asc,
      noticePeriod: settings.noticePeriod
    });
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setTempSettings({
      listPage: settings.listPage,
      listScroll: settings.listScroll,
      listCnt: settings.listViewCount,
      gridCnt: settings.gridViewCount,
      viewDesc: settings.desc,
      viewAsc: settings.asc,
      noticePeriod: settings.noticePeriod
    });
  };
  //#endregion

//#region 옵션 핸들러
function handleChange(e) {
  const { id, value } = e.target;
  setTempSettings(prev => {
    const newSettings = { ...prev };
    
    // 게시글 출력 방식
    if (id === 'chkall-pagging') {
      newSettings.listPage = 'Y';
      newSettings.listScroll = 'N';
    } else if (id === 'chkall-scroll') {
      newSettings.listPage = 'N';
      newSettings.listScroll = 'Y';
    }

    // 게시글 1회 출력 수량
    if (id === 'noticeCntList') {
      newSettings.listCnt = value;
      setErrorCntList(Number(value) > 50 || Number(value) < 0);
    } else if (id === 'noticeCntGrid') {
      newSettings.gridCnt = value;
      setErrorCntGrid(Number(value) % 3 !== 0 || Number(value) < 0 || Number(value) > 50);
    }

    // 리스트 정렬
    if (id === 'chkall-sort-new') {
      newSettings.viewDesc = 'Y';
      newSettings.viewAsc = 'N';
    } else if (id === 'chkall-sort-old') {
      newSettings.viewDesc = 'N';
      newSettings.viewAsc = 'Y';
    }
    
    if (id === 'noticeDay') {
      newSettings.noticePeriod = value;
      setErrorNoticeDay(Number(value) > 30 || Number(value) < 0);
    }

    return newSettings;
  });
}

  const optionCheck = async () => {
    if (errorCntList || errorCntGrid || errorNoticeDay) {
      alert("입력값에 오류가 있습니다.");
      return;
    }

    try {
      await dispatch(updateOption(tempSettings));
      setOpenModal(false);
      window.location.reload();
    } catch (error) {
      console.error("옵션 업데이트 실패:", error);
    }
  };

  //#endregion

  return (
    <div className='flex-1'>
      {categories && (
        <nav id="bo_cate">
          <h2>카테고리</h2>
          <ul id="bo_cate_ul">
            {/* <li
              className={activeCategory === 'all' ? "bo_cate_on" : ""}
              onClick={() => handleFilter('all')}
            >
              전체
            </li> */}
            {categories.map((category) => (
              <li
                key={category.id}
                className={activeCategory === category.id ? "bo_cate_on" : ""}
                onClick={() => handleFilter(category.id)}
              >
                {category.name}
              </li>
            ))}
          </ul>
        </nav>
      )}
      <div className="bo_inner">
        <div className="bo_top_wrap" style={{ position: 'relative', height: '5vh' }}>
          <h3 className='cate_title'>{activeCategoryName}<p>total.<span>{totalCount}</span></p></h3>
          <div>
            {admin && (
              <ul className="btn_bo_user" style={{ marginRight: '1rem' }}>
                <button type="button" title="게시글 작성" className="btn btn_b01 write-icon" onClick={goToContentInput}>
                  <span className="sound_only">게시글 작성</span>
                </button>
                <button type="button" title="게시글 설정" className="btn btn_b01 setting-icon" onClick={handleOpenModal}>
                  <span className="sound_only">게시글 설정</span>
                </button>
              </ul>
            )}
            <label id="typeLabel" htmlFor="type-switch" style={{ cursor: 'pointer' }}>
              <div className={`toggle ${gridMode ? "toggleGridmode" : ""}`}></div>
              <div className="type-group">
                <p
                  className="btn-type type-list"
                  onClick={() => setGridMode(false)}
                >
                  <i className="ri-list-unordered"></i>
                </p>
                <p
                  className="btn-type type-grid"
                  onClick={() => setGridMode(true)}
                >
                  <i className="ri-gallery-view-2"></i>
                </p>
              </div>
            </label>
          </div>
        </div>

        {gridMode ? (
          <NoticeGrid categoryId={selectCategoryID} dataStyle={dataStyle} vsData={vsData}/>  
        ):(
          <NoticeList categoryId={selectCategoryID} dataStyle={dataStyle} vsData={vsData} />
        )}
      </div>
      <div className={`modal fade ${openModal ? 'show' : ''}`} 
        style={{ display: openModal ? 'block' : 'none' }}
        tabIndex="-1"
        aria-hidden={!openModal}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content" style={{ backgroundColor: 'white' }}>
            <div className="modal-header">
              <h5 className="modal-title">게시글 설정</h5>
              <button type="button" 
                      className="btn-close" 
                      onClick={handleCloseModal}
                      aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div>
                <h4>게시글 출력 방식</h4>
                <input
                  type="checkbox"
                  id="chkall-pagging"
                  onChange={handleChange}
                  name="pagging"
                  value="pagging"
                  checked={tempSettings.listPage === 'Y'} 
                  className="selec_chk"
                />
                <label htmlFor="chkall-pagging">
                  <span>페이징</span>
                </label>

                <input
                  type="checkbox"
                  id="chkall-scroll"
                  onChange={handleChange}
                  name="scroll"
                  value="scroll"
                  checked={tempSettings.listScroll === 'Y'} 
                  className="selec_chk"
                />
                <label htmlFor="chkall-scroll">
                  <span>스크롤</span>
                </label>
              </div>
              <div>
                <h4>게시글 1회 출력 수량</h4>
                <label htmlFor="chkall-sort-new">
                  <span>리스트</span>
                </label>
                <input
                  id="noticeCntList"
                  type="number"
                  value={tempSettings.listCnt}
                  onChange={handleChange}
                />
                {errorCntList && <p className='pull-grid warning'>리스트는 50개까지 가능합니다</p>}
                <label htmlFor="chkall-sort-new">
                  <span>그리드</span>
                </label>
                <input
                  id="noticeCntGrid"
                  type="number"
                  value={tempSettings.gridCnt}
                  onChange={handleChange}
                />
                {errorCntGrid && <p className='pull-grid warning'>그리드는 3의 배수만 입력 가능합니다</p>}   
              </div>
              <div>
                <h4>리스트 정렬</h4>
                <input
                  type="checkbox"
                  id="chkall-sort-new"
                  onChange={handleChange}
                  name="newDate"
                  value="newDate"
                  checked={tempSettings.viewDesc === 'Y'} 
                  className="selec_chk"
                />
                <label htmlFor="chkall-sort-new">
                  <span>최신순 (DESC)</span>
                </label>
                <input
                  type="checkbox"
                  id="chkall-sort-old"
                  onChange={handleChange}
                  name="oldDate"
                  value="oldDate"
                  checked={tempSettings.viewAsc === 'Y'}
                  className="selec_chk"
                />
                <label htmlFor="chkall-sort-old">
                  <span>등록순 (ASC)</span>
                </label>
              </div>
              <div>
                <div className='pull-grid'>
                  <h4>게시물 베지 알림 기간 설정</h4>
                  <input
                    id="noticeDay"
                    type="number"
                    value={tempSettings.noticePeriod}
                    onChange={handleChange}
                  />일
                </div>
                {errorNoticeDay && <p className='pull-grid warning'>최대 기간은 30일 입니다.</p>}
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" 
                      className="btn btn-secondary" 
                      onClick={handleCloseModal}>
                닫기
              </button>
              <button type="button" 
                      className="btn btn-primary" 
                      onClick={optionCheck}>
                수정하기
              </button>
            </div>
          </div>
        </div>
        {openModal && <div className="modal-backdrop fade show"></div>}
      </div>
    </div>
  );
};

export default Notice;